import React from 'react';

export default function Elevator() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.7218 16.0005C30.7218 23.8553 24.3543 30.2228 16.4996 30.2228C8.64485 30.2228 2.27734 23.8553 2.27734 16.0005C2.27734 8.14583 8.64485 1.77832 16.4996 1.77832C24.3543 1.77832 30.7218 8.14583 30.7218 16.0005Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M14.9215 8.88867L14.9215 23.1109M10.9709 23.1109H18.8721C19.7449 23.1109 20.4524 22.4406 20.4524 21.6138V10.3857C20.4524 9.55894 19.7449 8.88867 18.8721 8.88867H10.9709C10.0981 8.88867 9.39062 9.55894 9.39062 10.3857V21.6138C9.39062 22.4406 10.0981 23.1109 10.9709 23.1109Z"
        stroke="black"
      />
      <path
        d="M24.5004 12.4443L26.2782 15.111H22.7227L24.5004 12.4443Z"
        fill="black"
      />
      <path
        d="M24.5004 19.5554L22.7227 16.8888H26.2782L24.5004 19.5554Z"
        fill="black"
      />
    </svg>
  );
}
